import { ReactElement } from 'react'
import styles from './WebRosterScreen.module.scss'
import { DesktopHeadlineLarge } from '../../Typography'
import { WrestlerSmallView } from '../../components/wrestler/WrestlerSmallView'
import { mapTitleToChampionString, Title } from '../../components/wrestler/Title'
import { Vakant, VakantTagChamps } from '../../components/wrestler/Vakant'
import { TagChampsSmallView } from '../../components/wrestler/TagChampsSmallView'
import { RosterScreenData } from './RosterScreen'
import { STRINGS } from '../../content/strings'

type Props = {
  data: RosterScreenData
}

export const WebRosterScreen = ({
  data: {
    collectorChampion: collectorsChamp,
    collectors,
    fightbackChampion: fightbackChamp,
    onWrestlerClick,
    wrestlers,
    tagTeamChampions,
    officials,
  },
}: Props): ReactElement => {
  return (
    <div className={styles.container}>
      <div className={styles.decoratedSection}>
        <div className={styles.section}>
          <DesktopHeadlineLarge>Champions</DesktopHeadlineLarge>
          <div className={styles.bigRow}>
            {fightbackChamp !== undefined ? (
              <div className={styles.bigBox} key={fightbackChamp.id}>
                <WrestlerSmallView
                  profilbild={fightbackChamp.profilbild}
                  name={fightbackChamp.name}
                  onClick={(): void => {
                    // TODO: Championship History
                    onWrestlerClick(fightbackChamp)
                  }}
                  title={mapTitleToChampionString(Title.FIGHTBACK_CHAMPION)}
                  bigFont={true}
                />
              </div>
            ) : (
              <div className={styles.bigBox}>
                <Vakant title={mapTitleToChampionString(Title.FIGHTBACK_CHAMPION)} />
              </div>
            )}
            {collectorsChamp !== undefined ? (
              <div className={styles.bigBox} key={collectorsChamp.id}>
                <WrestlerSmallView
                  profilbild={collectorsChamp.profilbild}
                  name={collectorsChamp.name}
                  onClick={(): void => {
                    // TODO: Championship History
                    onWrestlerClick(collectorsChamp)
                  }}
                  title={mapTitleToChampionString(
                    Title.COLLECTORS_CHAMPION,
                    collectorsChamp.medaillen,
                  )}
                  bigFont={true}
                />
              </div>
            ) : (
              <div className={styles.bigBox}>
                <Vakant title={mapTitleToChampionString(Title.COLLECTORS_CHAMPION)} />
              </div>
            )}
            {tagTeamChampions !== undefined && tagTeamChampions.length === 2 ? (
              <div className={styles.bigBox}>
                {/* TODO: Insert Title History View onClick */}
                <TagChampsSmallView
                  profilbilder={tagTeamChampions.map((wrestler) => wrestler.profilbild)}
                  namen={tagTeamChampions.map((wrestler) => wrestler.name)}
                  firstStables={tagTeamChampions[0].zugehoerigkeit}
                  secondStables={tagTeamChampions[1].zugehoerigkeit}
                  onFirstClick={(): void => {
                    onWrestlerClick(tagTeamChampions[0])
                  }}
                  onSecondClick={(): void => {
                    onWrestlerClick(tagTeamChampions[1])
                  }}
                />
              </div>
            ) : (
              <div className={styles.bigBox}>
                <VakantTagChamps />
              </div>
            )}
          </div>
        </div>
        <div className={styles.section}>
          <DesktopHeadlineLarge>Collectors</DesktopHeadlineLarge>
          <div className={styles.smallRow}>
            {collectors !== undefined &&
              collectors.length > 0 &&
              collectors.map((wrestlerData) => (
                <div className={styles.smallBox} key={wrestlerData.name}>
                  <WrestlerSmallView
                    profilbild={wrestlerData.profilbild}
                    name={wrestlerData.name}
                    onClick={(): void => onWrestlerClick(wrestlerData)}
                    title={STRINGS.collectorsMedal}
                    bigFont={true}
                  />
                </div>
              ))}
            {Array.from({
              length: Math.max(0, 4 - (collectors !== undefined ? collectors.length : 0)),
            }).map((_, index) => (
              <div className={styles.smallBox} key={index}>
                <Vakant title={STRINGS.collectorsMedal} />
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className={styles.section}>
        <DesktopHeadlineLarge>Wrestlers</DesktopHeadlineLarge>
        <div className={styles.smallRow}>
          {wrestlers !== undefined &&
            wrestlers.length > 0 &&
            wrestlers.map((wrestlerData) => (
              <div className={styles.smallBox} key={wrestlerData.name}>
                <WrestlerSmallView
                  profilbild={wrestlerData.profilbild}
                  name={wrestlerData.name}
                  onClick={(): void => onWrestlerClick(wrestlerData)}
                  title={
                    wrestlerData.titel.length > 0
                      ? mapTitleToChampionString(wrestlerData.titel[0])
                      : null
                  }
                  bigFont={true}
                />
              </div>
            ))}
        </div>
      </div>
      <div className={styles.section}>
        <DesktopHeadlineLarge>Officials</DesktopHeadlineLarge>
        <div className={styles.smallRow}>
          {officials !== undefined &&
            officials.length > 0 &&
            officials.map((officialsData) => (
              <div className={styles.smallBox} key={officialsData.name}>
                <WrestlerSmallView
                  profilbild={officialsData.profilbild}
                  name={officialsData.name}
                  onClick={(): void => onWrestlerClick(officialsData)}
                  title={
                    officialsData.titel.length > 0
                      ? mapTitleToChampionString(officialsData.titel[0])
                      : null
                  }
                  bigFont={true}
                />
              </div>
            ))}
        </div>
      </div>
    </div>
  )
}
